import React from "react";
import solarImage from "../assests/images/detailsolar.png";
import mapImage from "../assests/images/map.png";
import { Route, Routes, Navigate } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MobileStepper from "@mui/material/MobileStepper";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import SwipeableViews from "react-swipeable-views";

import routesArr from "../routes";
import { autoPlay } from "react-swipeable-views-utils";

const AutoPlaySwipeableViews = autoPlay(SwipeableViews);

const images = [
  {
    label: "",
    description: "",
    imgPath: solarImage,
  },
  {
    label: "",
    description: "",
    imgPath: mapImage,
  },
];

function getRoutes(routesParamArr) {
  return routesParamArr.map((prop, key) => {
    // if (prop.collapse) {
    //   return this.getRoutes(prop.views);
    // }
    if (prop.layout === "/auth") {
      return <Route path={prop.path} Component={prop.component} key={key} />;
    } else {
      return null;
    }
  });
}

function AuthLayout(props) {
  const theme = useTheme();
  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = images.length;

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleStepChange = (step) => {
    setActiveStep(step);
  };
  return (
    <>
      <section className="login-outer">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6 login-left">
              <Box className="lets_autoPlaySwipeableViews_block">
                <Paper square elevation={0} style={{ height: "auto" }}>
                  {/* Add your label and description elements here */}
                </Paper>

                <AutoPlaySwipeableViews
                  axis={theme.direction === "rtl" ? "x-reverse" : "x"}
                  index={activeStep}
                  onChangeIndex={handleStepChange}
                  enableMouseEvents
                >
                  {images.map((step, index) => (
                    <div key={step.label}>
                      {Math.abs(activeStep - index) <= 2 ? (
                        <Box
                          component="img"
                          src={step.imgPath}
                          alt={step.label}
                        />
                      ) : null}
                      <Typography className="type_onboarding_list_block">
                        {images[activeStep].label}
                      </Typography>
                      <Typography className="text_list_vendor_react_block">
                        {images[activeStep].description}
                      </Typography>
                    </div>
                  ))}
                </AutoPlaySwipeableViews>

                <MobileStepper
                  steps={maxSteps}
                  position="static"
                  activeStep={activeStep}
                  variant="dots"
                  style={{ justifyContent: "center" }}
                />
              </Box>
            </div>

            <div className="col-md-6 login-form-ot">
              <Routes>
                {getRoutes(routesArr)}

                {/* <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/mobile-auth" element={<MobileLogin />} /> */}

                <Route path="*" element={<Navigate to="/login" />} />
                {/* <Redirect from="*" to="/auth/login" /> */}
              </Routes>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default AuthLayout;
